/**
 * PATH: packages/email-hub/src/feature/personal/personalInboxSelectors.ts
 * FILE_ID: EMAILHUB-PERSONAL-SELECTORS-001
 * PURPOSE: Pure collapsed-row derivations shared by the Personal inbox UI.
 */

import type { PersonalEmail } from './usePersonalData'

export function countPinsForEmailCopies(
  email: PersonalEmail,
  pinCountByEmail: ReadonlyMap<string, number>,
): number {
  const emailIds = email.present_in_orgs.length > 0
    ? email.present_in_orgs.map((copy) => copy.email_id)
    : [email.id]
  return emailIds.reduce(
    (count, emailId) => count + (pinCountByEmail.get(emailId) ?? 0),
    0,
  )
}
